<!-- Versión editable -->
<div id="financialService" *ngIf="isEditable">
  <h3>Servicio financiero</h3>
  <form [formGroup]="formFinancialService">
    <div class="wrapperG4">
      <div class="controlWrapper">
        <label for="">Compañia <span class="required">*</span></label>
        <div class="customSelect">
          <select
            type="text"
            formControlName="companyName"
            (change)="onChangeCompany()"
          >
            @for(company of listCompanies; track company.value){
            <option [value]="company.value">
              {{ company.name }}
            </option>
            }
          </select>
        </div>
      </div>
      <div class="controlWrapper">
        <label for="">Distribuidor <span class="required">*</span></label>
        <div class="customSelect">
          <select
            type="text"
            formControlName="dealerId"
            [attr.data-selected]="dealerId"
            (ngModelChange)="updateBranches()"
          >
            <option *ngFor="let dealer of dealers" [ngValue]="dealer.id">
              {{ dealer.name }}
            </option>
          </select>
        </div>
      </div>
      <!-- Mostrar solo si el usuario puede seleccionar Sucursal -->
      <div class="controlWrapper">
        <label for="">Sucursal <span class="required">*</span></label>
        <div class="customSelect">
          <select [attr.data-selected]="dealerBranchId" formControlName="dealerBranchId">
            @if(!hasBranches && dealerId !== null){
              <option [value]="null" hidden selected>
                {{ "No existen sucursales disponibles." }}
              </option>
            }@else {
            <option *ngFor="let dealerBranch of dealerBranches" [ngValue]="dealerBranch.id">
              {{ dealerBranch.name }}
            </option>
            }
          </select>
        </div>
      </div>
      <div class="controlWrapper">
        <div *ngIf="idQuote" class="numero">
          <label for="">Número</label>
          <input
            type="number"
            [value]="idQuote"
            disabled
            (blur)="onInputFocus()"
          />
        </div>
      </div>
      <div class="controlWrapper nombre">
        <label for=""
          >Nombre de la cotización <span class="required">*</span></label
        >
        <input
          name=""
          type="text"
          id="price"
          formControlName="quoteName"
          (blur)="onInputFocus()"
        />
      </div>
      <div class="controlWrapper">
        <label for="">Vigencia <span class="required">*</span></label>
        <div class="customSelect">
          <select
            type="text"
            formControlName="daysOfValidity"
            (blur)="onInputFocus()"
            >
            <option [value]="15">15 días</option>
            <option [value]="30">30 días</option>
          </select>
        </div>
      </div>
      <div class="controlWrapper" *ngIf="idQuote">
        <label for="">Estado</label>
        <div class="customSelect">
          <select type="text" formControlName="statusType">
            <option
              *ngFor="let status of financialCalculator.statusType"
              [value]="status.value"
            >
              {{ status.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- Versión sólo lectura -->
<div id="financialService" class="readOnly" *ngIf="!isEditable">
  @if (!isModeEdition() && showReadonlyQuoteBelongsToOtherUser) {
    <div class="author">
      Esta cotización pertenece a {{ userName }} y no puede ser modificada.
    </div>
  }
  <h3>Servicio financiero</h3>
  <div class="wrapperG4">
    <div class="controlWrapper">
      <label>Compañia</label>
      <span class="value">{{ formFinancialService.controls['companyName'].value }}</span>
    </div>

    <div class="controlWrapper">
      <label>Distribuidor</label>
      <span class="value">
        {{ getNameById(formFinancialService.controls['dealerId'].value, 'dealer') }}
      </span>
    </div>

    <div class="controlWrapper">
      <label>Sucursal</label>
      <span class="value">
        {{ getNameById(formFinancialService.controls['dealerBranchId'].value, 'branch') }}
      </span>
    </div>

    <div class="controlWrapper">
      <label>Número</label>
      <span class="value">{{ idQuote }}</span>
    </div>

    <div class="controlWrapper nombre">
      <label>Nombre de la cotización</label>
      <span class="value">{{ formFinancialService.controls['quoteName'].value }}</span>
    </div>

    <div class="controlWrapper">
      <label>Vigencia</label>
      <span class="value">{{ formFinancialService.controls['daysOfValidity'].value }} días</span>
    </div>

    <div class="controlWrapper">
      <label>Estado</label>
      @if (showStatusSelectInReadOnly) {
        <div class="customSelect" [formGroup]="formFinancialService">
          <select type="text" formControlName="statusType">
            <option
              *ngFor="let status of statusSelectOptions"
              [value]="status.value"
            >
              {{ status.name }}
            </option>
          </select>
        </div>
      } @else {
        <span class="value">{{ getStatus(formFinancialService.controls['statusType'].value) }}</span>
      }
    </div>
  </div>
</div>
